import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Badge,
  Button
} from "shards-react";
import '../../views/loaderStyles.css'; // Import the loader styles
import { useAuth } from '../../context/AuthContext';

const UserActivity = ({ title, uuid }) => {
  const [activityData, setActivityData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  
  // Set default dates to current date
  const currentDate = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { logout } = useAuth(); 

  const [dateWarning, setDateWarning] = useState(""); // State for date warning


  const itemsPerPage = 5; // Number of items per API call

  const fetchActivityData = async (page) => {
   // if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) return;
  //  const companyId = localStorage.getItem('company_id');
  const token = localStorage.getItem("token");
  //  const comp_id=localStorage.getItem('company_id');
   // const token=localStorage.getItem('token');
    
    if(!token||token==''){ 
     logout();
   }



    setLoading(true);

    try {
      const response = await fetch("https://vaptlabreport.com/shieldapi/metrics_per_uuid.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          uuid: [uuid],
          start_date: startDate,
          end_date: endDate,
          page: page
        }),
      });

      const result = await response.json();
      if (result.status === "success" && result.data.length > 0) {
        setDateWarning("");
        const fetchedData = result.data;
        setActivityData(fetchedData);
        const totalCount = result.count || 0;
        setTotalPages(Math.ceil(totalCount / itemsPerPage));
      } else {
        // Handle the error status gracefully
        console.error("Error fetching data:", result.message || "Unknown error");
        setActivityData([]); // Clear existing data on error
        setTotalPages(0); // Reset total pages
        setHasMore(false); // No more pages to fetch
      }
    } catch (error) {
      console.error("Error fetching detection history:", error);
      setActivityData([]); // Clear existing data on fetch error
      setTotalPages(0); // Reset total pages
      setHasMore(false); // No more pages to fetch
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchActivityData(page); // Fetch activity data when the component mounts
  }, [page, startDate, endDate]); // Add startDate and endDate to the dependencies

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // const renderDetections = (item) => {
  //   const detectionSeverityMap = {
  //     isRooted: { label: "Root Detected", severity: "danger" },
  //     isEmulator: { label: "Emulator Detected", severity: "warning" },
  //     isUsbDebuggingEnabled: { label: "USB Debugging Enabled", severity: "info" },
  //     is_usb_connected: { label: "USB Connected", severity: "info" },
  //     isDeveloperOptionsEnabled: { label: "Developer Options Enabled", severity: "warning" },
  //     isProxyEnabled: { label: "Proxy Enabled", severity: "danger" },
  //     isDebugging: { label: "Debugging Enabled", severity: "warning" }
  //   };

  //   return Object.keys(detectionSeverityMap).map((key) => {
  //     if (item[key] === "1") {
  //       const detection = detectionSeverityMap[key];
  //       return (
  //         <Badge
  //           key={key}
  //           outline
  //           pill
  //           theme={detection.severity}
  //           className="mr-1"
  //         >
  //           {detection.label}
  //         </Badge>
  //       );
  //     }
  //     return null;
  //   });
  // };

  // const getSeverityColor = (item) => {
  //   const severityColorMap = {
  //     danger: 'red',
  //     warning: 'orange',
  //     info: '#00b8d8',
  //   };

  //   for (const key in item) {
  //     if (item[key] === "1") {
  //       const detectionSeverity = renderDetections(item).find(detection => detection && detection.props && detection.props.theme);
  //       if (detectionSeverity) {
  //         return severityColorMap[detectionSeverity.props.theme];
  //       }
  //     }
  //   }
  //   return 'green';
  // };



  const renderDetections = (item) => {
    const detectionSeverityMap = {
      isRooted: { label: "Root Detected", severity: "danger" },
      isEmulator: { label: "Emulator Detected", severity: "warning" },
      isUsbDebuggingEnabled: { label: "USB Debugging Enabled", severity: "info" },
      is_usb_connected: { label: "USB Connected", severity: "info" },
      isDeveloperOptionsEnabled: { label: "Developer Options Enabled", severity: "warning" },
      isProxyEnabled: { label: "Proxy Enabled", severity: "danger" },
      isDebugging: { label: "Debugging Enabled", severity: "warning" },


      isMockLocationEnabled: { label: "Mock Location Enabled", severity: "danger" },
      isInstalledFromValidSource: { label: "Installed From Invalid Source", severity: "warning" },
      isVPNEnabled: { label: "VPN Enabled", severity: "warning" },
      isHooking: { label: "Hooking Detected", severity: "danger" },
      isScreenshotDetected: { label: "Screenshot Detected", severity: "warning" },
      isTampered: { label: "App Tampered", severity: "danger" },
      isScreenRecording: { label: "Screen Recording Detected", severity: "warning" },
      isAppCloned: { label: "App Cloned", severity: "danger" },

    };
  
    return Object.keys(detectionSeverityMap).map((key) => {
      // Check if the detection exists and is active
      if (item[key] === "1" || item[key] === 1) {
        const detection = detectionSeverityMap[key];
        return (
          <Badge
            key={key}
            outline
            pill
            theme={detection.severity}
            className="mr-1"
          >
            {detection.label}
          </Badge>
        );
      }
      return null;
    });
  };
  
  const getSeverityColor = (item) => {
    const severityPriority = {
      danger: 1, // Highest priority
      warning: 2,
      info: 3,
    };
  
    const detectionSeverityMap = {
      isRooted: "danger",
      isEmulator: "warning",
      isUsbDebuggingEnabled: "info",
      is_usb_connected: "info",
      isDeveloperOptionsEnabled: "warning",
      isProxyEnabled: "danger",
      isDebugging: "warning",
	     isMockLocationEnabled: "danger", // Mock Location Enabled is high
      isInstalledFromValidSource: "warning", // Installed from invalid source is high
      isVPNEnabled: "warning", // VPN Enabled is medium
      isHooking: "danger", // Hooking Detected is high
      isScreenshotDetected: "warning", // Screenshot Detected is medium
      isTampered: "danger", // App Tampered is high
      isScreenRecording: "warning", // Screen Recording Detected is medium
      isAppCloned: "danger",
    };
  
    // Default color is green (no detections)
    let highestSeverity = "green";
  
    Object.keys(detectionSeverityMap).forEach((key) => {
      if (item[key] === "1" || item[key] === 1) {
        const severity = detectionSeverityMap[key];
        if (
          severityPriority[severity] &&
          (!severityPriority[highestSeverity] || severityPriority[severity] < severityPriority[highestSeverity])
        ) {
          highestSeverity = severity;
        }
      }
    });
  
    const severityColorMap = {
      danger: "red",
      warning: "orange",
      info: "#00b8d8",
      green: "green",
    };
  
    return severityColorMap[highestSeverity] || "green";
  };
  


  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  const groupByDateAndTime = (data) => {
    const groupedData = {};

    data.forEach((item) => {
      const date = formatDate(item.received_at);
      const time = formatTime(item.received_at);

      if (!groupedData[date]) {
        groupedData[date] = {};
      }

      if (!groupedData[date][time]) {
        groupedData[date][time] = [];
      }

      groupedData[date][time].push(item);
    });

    return groupedData;
  };

  const groupedActivityData = groupByDateAndTime(activityData);

  // const renderPaginationNumbers = () => {
  //   const pageNumbers = [];

  //   for (let i = 1; i <= totalPages; i++) {
  //     pageNumbers.push(
  //       <Button
  //         key={i}
  //         size="sm"
  //         theme={i === page ? "primary" : "white"}
  //         onClick={() => changePage(i)}
  //       >
  //         {i}
  //       </Button>
  //     );
  //   }

  //   return pageNumbers;
  // };

  const renderPaginationNumbers = () => {
    const pageNumbers = [];
    const maxVisibleButtons = 5; // Adjust this to control how many buttons are visible
    const startPage = Math.max(1, page - Math.floor(maxVisibleButtons / 2));
    const endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
  
    if (startPage > 1) {
      pageNumbers.push(
        <Button key="first" size="sm" theme="white" onClick={() => changePage(1)}>
          1
        </Button>
      );
      if (startPage > 2) {
        pageNumbers.push(<span key="start-ellipsis">...</span>);
      }
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Button
          key={i}
          size="sm"
          theme={i === page ? "primary" : "white"}
          onClick={() => changePage(i)}
        >
          {i}
        </Button>
      );
    }
  
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<span key="end-ellipsis">...</span>);
      }
      pageNumbers.push(
        <Button
          key="last"
          size="sm"
          theme="white"
          onClick={() => changePage(totalPages)}
        >
          {totalPages}
        </Button>
      );
    }
  
    return pageNumbers;
  };
  

  return (
    <Card small className="user-activity mb-4">
      <CardHeader className="border-bottom d-flex justify-content-between align-items-center">
        <h6 className="m-0">{title}</h6>
        <div className="d-flex align-items-center">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Start Date"
            style={{
              marginRight: '10px',
              padding: '5px 10px',
              borderRadius: '5px',
              border: '1px solid #ddd',
              fontSize: '0.9em'
            }}
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => {
              if (new Date(e.target.value) >= new Date(startDate)) {
                setEndDate(e.target.value);
                 setDateWarning(""); 
     
              } else {
              
                 setDateWarning("End date cannot be before start date."); 
     
              }
            }}
            placeholder="End Date"
            style={{
              padding: '5px 10px',
              borderRadius: '5px',
              border: '1px solid #ddd',
              fontSize: '0.9em'
            }}
          />
        </div>
      </CardHeader>

      <CardBody className="p-0">

      
        {loading && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}

         
         {dateWarning && (
          <p className="text-danger" style={{ marginLeft: '10px' ,textAlign: 'center' }}>
            {dateWarning}
          </p>
        )}


        {!loading && Object.keys(groupedActivityData).length === 0 && (
          <p className="text-center">No activity found.</p>
        )}



        {!loading && Object.keys(groupedActivityData).map((date) => (
          <div key={date} className="user-activity__item pr-3 py-3">
            <div className="user-activity__item__icon ">
              <i className="material-icons" style={{color:'green',fontSize: '25px',marginTop: '-2px'}}> &#xE868; </i>
            </div>
            <div className="user-activity__item__content">
              <span className="text-dark font-weight-bold">{date}</span>

              {Object.keys(groupedActivityData[date]).map((time) => {
                const items = groupedActivityData[date][time];
                const color = getSeverityColor(items[0]);

                return (<div key={time} className="timeline-entry" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    boxShadow: `0 0 10px ${color}`,
                  }} />
                  <p className="text-muted mb-2" style={{ margin: '0', padding: '0',marginTop:'6px' }}>{time}</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {items.map((item, idx) => (
                      <div key={idx} className="detection-entry">
                        {renderDetections(item)}
                      </div>
                    ))}
                  </div>
                </div>
                   );
              })}
            </div>
          </div>
        ))}
      </CardBody>

      <CardFooter className="border-top">
        <div className="pagination-controls d-flex justify-content-between">
          <Button size="sm" disabled={page === 1} onClick={() => changePage(page - 1)}>
            Prev
          </Button>
          <div>{renderPaginationNumbers()}</div>
          <Button size="sm" disabled={page === totalPages} onClick={() => changePage(page + 1)}>
            Next
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

UserActivity.propTypes = {
  title: PropTypes.string,
  uuid: PropTypes.string.isRequired
};

export default UserActivity;
